import React, { useState } from 'react';
import { Link, Route, useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { logoutAction } from "../../../redux/actions/LoginActions";
import { Modal, Button } from 'react-bootstrap'
import './header.scss'
import "../../../_base.scss"
import ForgetPassword from '../../Forget-Password/ForgetPassword';
import MyProfile from '../../myProfile/MyProfile';
import ChangePassword from '../../ChangePassword/ChangePassword';
const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isPassOpen, setIsPassOpen] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate()
  let { data } = JSON.parse(localStorage.getItem('authUser'))



  const openProfile = () => {
    setIsOpen(true)
  }
  const closeProfile = () => {
    setIsOpen(false)
  }

  const handleLogout = () => {
    dispatch(logoutAction());
    setIsOpen(false)
    navigate('/')
  }
  const openPassModal = () => {
    setIsPassOpen(true)
    setIsOpen(false)
    closeProfile()
    //dateData(value)
  }
  const closePsssModal = () => {
    setIsPassOpen(false)
  }

  const passwordConfig = {
    isPassOpen,
    closePsssModal,

  }
  return (
    <div className='header'>
      {isPassOpen && <ChangePassword {...passwordConfig} />}
      {isOpen && <Modal
        dialogClassName='profilemodal'
        contentClassName="headerContent"
        backdropClassName='backdrop'
        onHide={closeProfile}
        show={isOpen}
      >
        <Modal.Header className='modalheader'>
          <Link style={{textDecoration:"none"}} onClick={closeProfile} to="/MyProfile">My Profile </Link>
        </Modal.Header>
        <Modal.Body style={{ padding: '3px' }}>
          <div className="modalchPass">
            <Link style={{textDecoration:"none"}} onClick={openPassModal} to="/changepassword">Change Password</Link>
          </div>

        </Modal.Body>

        <div >
          Email: {data.email}
        </div>
        <Modal.Footer>
          <Button style={{ background: `#0dcaf0`, padding: '2px 12px' }} onClick={handleLogout} >Sign Out</Button>
        </Modal.Footer>
      </Modal>
      }
      <div className='header_logoutbtn'>
        <button className='header_logoutbtn-btn' onClick={openProfile}>Hi, {data.name}</button>
      </div>
    </div>
  )
};

export default Header;
